import quillConfig from '@/quill/config'

/**
 * Quill config for the email-signature editor. Like the composer's slim toolbar,
 * but WITH the placeholder button so an agent can insert placeholders that are
 * filled per reply (the agent who answered + the store/POS that answered) — e.g.
 * a shared mailbox still signs off "Artem Schander / Rundholz Berlin".
 *
 * The variable `value` is the placeholder key; ConversationThread.fillSignatureVariables
 * substitutes the same keys at compose time, so this list and that map must agree.
 */
// `label` is an i18n KEY, not a display string — the placeholder module translates it
// at render time (see quill/toolbar/placeholder/module.js). German lives in i18n/de.js
// with everything else, so the picker follows the admin's language.
export const signatureVariables = [
    { label: 'Employee name', value: 'user.name' },
    { label: 'Employee email', value: 'user.email' },
    { label: 'Point of sale / location', value: 'pos.name' },
    { label: 'CMS name', value: 'cms.name' }
]

const signatureQuillConfig = {
    ...quillConfig,
    modules: {
        ...quillConfig.modules,
        toolbar: {
            container: [
                ['bold', 'italic', 'underline'],
                [{ list: 'ordered' }, { list: 'bullet' }],
                ['link'],
                ['placeholder'],
                ['text-generation'],
                ['clean']
            ]
        },
        placeholder: {
            variables: signatureVariables,
            placeholder: 'Search variable...'
        }
    }
}

export default signatureQuillConfig
